import React from 'react';
import { faCarMirrors } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function CarMirrorsSolidIcon(props) {
  return <FontAwesomeIcon icon={faCarMirrors} {...props} />;
}
